"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AccordionSection = _ref => {
  let {
    content,
    expanded,
    onTitleClick,
    sectionKey,
    setExpanded,
    title,
    titleElement,
    headingLevel = 3
  } = _ref;
  const sectionId = (0, _react.useId)();
  const tabId = (0, _react.useId)();
  const key = sectionKey || sectionId;
  const isExpanded = expanded === key;
  const Title = titleElement || "div";
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "p-accordion__group"
  }, /*#__PURE__*/_react.default.createElement(Title, {
    role: titleElement ? null : "heading",
    "aria-level": titleElement ? null : headingLevel,
    className: "p-accordion__heading"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-controls": "#".concat(sectionId),
    "aria-expanded": isExpanded ? "true" : "false",
    className: "p-accordion__tab",
    id: tabId,
    onClick: () => {
      if (isExpanded) {
        setExpanded(null, null);
      } else {
        setExpanded(key, title);
      }
      onTitleClick && onTitleClick(!isExpanded, key);
    },
    role: "tab",
    type: "button"
  }, title)), /*#__PURE__*/_react.default.createElement("section", {
    "aria-hidden": isExpanded ? "false" : "true",
    "aria-labelledby": tabId,
    className: "p-accordion__panel",
    id: sectionId,
    role: "tabpanel"
  }, content));
};
var _default = exports.default = AccordionSection;